import gql from 'graphql-tag';

export const GET_LOCATIONS = gql`
  query LenderPerformanceLocations {
    locations {
      locationId
      locationName
    }
  }
`;
